import {
    SET_DATA_QR,
    SET_ERROR_QR
} from '../types'

const initialState = {
    resultado: {},
    message: '',
    error: ''
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_DATA_QR:
            return {
                ...action.payload
            }
        case SET_ERROR_QR:
            return {
                ...action.payload
            }
        default: return state
    }
}